module.exports = __webpack_public_path__ + "static/media/recurring_unassigned.8efbb3c5.svg";